<form [formGroup]="tagForm">
    <p-dialog
        header="Create New Tags"
        [modal]="true" [(visible)]="showDialog"  (onHide)="close()"
        [style]="{width: '45vw'}"  appendTo="body">

        <app-subscription-limit-message
            *ngIf="subscriptionLimitReached"
            [subscriptionLimit]="subscriptionLimit"
            [moduleName]="'Tags'">
        </app-subscription-limit-message>

        <div *ngIf="!subscriptionLimitReached" class="card" style="min-height: 300px;">
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Tag Name</label>
                    <input type="text" pInputText formControlName="name">
                </div>
                <div *ngIf="detailsFormErrors?.name" class="p-invalid">
                    <small>{{ detailsFormErrors?.name }}</small>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label class="p-mr-2">Tag color</label>
                    <p-colorPicker formControlName="color" appendTo="body"></p-colorPicker>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" type="button" (click)="close()" class="p-button-secondary"></button>
            <button *ngIf="!subscriptionLimitReached" pButton type="submit" label="Save" (click)="submitForm()" [disabled]="tagForm.invalid"></button>
        </ng-template>
    </p-dialog>
</form>
